import { breakpoints } from '@/src/utils/mediaQuery';
import { Button, DismissButton, Heading4, P } from '@ovotech/element-v5';
import styled from 'styled-components';

export const StyledDialog = styled.dialog`
  width: 100%;
  max-width: 576px;
  max-height: 80dvh;
  margin: auto auto 0;
  padding: 0;
  border: none;
  border-radius: var(--border-radius-lg) var(--border-radius-lg) 0 0;
  background: var(--color-surface-bright);

  /* The dialog takes focus on open so its buttons don't; it isn't a control, so no ring. */
  &:focus-visible {
    outline: none;
  }

  /* Older browsers don't pass custom properties to ::backdrop. */
  &::backdrop {
    background: var(--color-brand-fixed-dark, #00261c);
    opacity: 0.75;
    backdrop-filter: blur(4px);
  }

  @media ${breakpoints.smallUp} {
    width: calc(100% - 2 * var(--space-400));
    max-width: 550px;
    max-height: 500px;
    margin: auto;
    border-radius: var(--border-radius-2xl);
  }
`;

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-400);
  padding: var(--space-1200) var(--space-800)
    max(var(--space-400), env(safe-area-inset-bottom));
  text-align: center;

  @media ${breakpoints.smallUp} {
    padding: var(--space-800) var(--space-600);
  }
`;

export const StyledDismissButton = styled(DismissButton)`
  position: absolute;
  top: 10px;
  right: 10px;
  width: 32px;
  height: 32px;
`;

export const StyledIllustration = styled.img`
  width: 80px;
  height: 80px;

  @media ${breakpoints.smallUp} {
    width: 120px;
    height: 120px;
  }
`;

export const StyledHeading = styled(Heading4)`
  color: var(--color-surface-on-surface);
`;

export const StyledBody = styled(P)`
  line-height: var(--font-line-height-lg);
`;

export const StyledButton = styled(Button)`
  width: 100%;
  margin-top: var(--space-400);

  @media ${breakpoints.smallUp} {
    width: auto;
    margin-top: 0;
  }
`;
